import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDishTypeAdditionalIngredientsDetailsArgs } from '../graphql/transformers'
import { UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS } from '../redux/action-types'

const useUpdateDishTypeAdditionalIngredientsDetailsMutation = () => {
  const dispatch = useDispatch()

  const {
    isAdditionalIngredientsDetailsLoading,
    additionalIngredientsDetailsError,
  } = useSelector(store => store.dishTypes.dishType)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateDishTypeAdditionalIngredientsDetailsArgs(data),
        },
        dispatch,
        UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isAdditionalIngredientsDetailsLoading,
      error: additionalIngredientsDetailsError,
    },
  ]
}

export default useUpdateDishTypeAdditionalIngredientsDetailsMutation
